export default __webpack_public_path__ + "static/media/IMG-20250105-WA0008.dc0ab5e4.jpg";